import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { TextField } from '@mui/material';
import InputWrapper from './InputWrapper';
import i18next from 'i18next';

const TextInput = ({inputItem, disabled}) => {
  const formMethods = useFormContext();
  const {
    control,
    formState: { errors },
    clearErrors,
  } = formMethods;
  const text = useWatch({ control, name: `${inputItem.fieldName}` });

  return (
    <InputWrapper inputItem={inputItem}>
      <Controller
        control={control}
        name={inputItem.fieldName}
        rules={{
          validate: (value) => {
              const isEmpty = !value || value.length === 0;
              if (isEmpty) {
                return i18next.t("infos.required");
              } else {
                clearErrors(inputItem.fieldName)
              }
          }
        }}
        render={({ field }) => (
          <TextField
            {...field}
            id="attribute-label-id"
            variant="outlined"
            placeholder={inputItem.placeholder}
            fullWidth
            disabled={disabled}
            value={text}
            error={!!errors[inputItem.fieldName]}
            helperText={
              !!errors[inputItem.fieldName] ? errors[inputItem.fieldName].message : ""
            }
          />
        )}
      />
    </InputWrapper>
  );
}

export default TextInput;